import { useMemo } from "react";
import { Constants, ILocalStorageApp } from "../utils/constants";
import { useParams } from "react-router-dom";


export const useAppLocalStorage = () => {
  const params = useParams();
  const clientDomain = window.location.hostname;

  const local = localStorage.getItem(Constants.LOCALSTORAGE.app) || '';

  const app = useMemo(() => {
    if(
      (clientDomain.includes('yelly') || clientDomain.includes('localhost'))
      && !params.slug
    ) return null;

    if(local) return JSON.parse(local) as ILocalStorageApp;

      return null;
  }, [clientDomain, local, params.slug]);

  return { app };
}